__turbopack_context__.v({
  "root": "IconCategoryWrapper-module-scss-module__daD3IW__root",
});
